import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { setBreadcrumbsList } from 'src/store/breadcrumbs';

import { CustomLink } from 'src/components';

import { BREADCRUMBS_DATA } from 'src/constants';

import { ContactsMailIcon, EllipseImage, LetterBox, PinIcon, TimeIcon } from 'src/assets';
import './contacts.scss';

export const Contacts = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBreadcrumbsList(BREADCRUMBS_DATA.CONTACTS));
  }, [dispatch]);

  return (
    <div className="contacts">
      <div className="contacts-content">
        <h1 className="contacts-title">{t('contacts:title')}</h1>

        <div className="contacts-section">
          <div className="contacts-iframe-wrapper">
            <div className="contacts-iframe-background" />
            <iframe
              className="contacts-iframe"
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12420.374694947746!2d-77.00917657063903!3d38.89897315104257!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b8205cad8bdb%3A0xf3b0c7d2e0a9d9ab!2s899%20North%20Capitol%20St%20NE%20%23900%2C%20Washington%2C%20DC%2020002%2C%20%D0%A1%D0%A8%D0%90!5e0!3m2!1sru!2sua!4v1731527708280!5m2!1sru!2sua"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            />
          </div>
          <div className="contacts-info">
            <div className="contacts-info-item">
              <div className="contacts-info-item-image-wrapper">
                <img className="contacts-info-item-image" src={PinIcon} alt={PinIcon} />
              </div>
              <div className="contacts-info-item-content">
                <h3 className="contacts-info-item-title">{t('contacts:address')}</h3>
                <div className="contacts-info-item-subtitle">
                  899 North Capitol St NE #900, Washington, DC 20002, USA
                </div>
              </div>
            </div>
            <div className="contacts-info-item">
              <div className="contacts-info-item-image-wrapper">
                <img
                  className="contacts-info-item-image"
                  src={ContactsMailIcon}
                  alt={ContactsMailIcon}
                />
              </div>
              <div className="contacts-info-item-content">
                <h3 className="contacts-info-item-title">{t('contacts:getInTouch')}</h3>
                <div className="contacts-info-item-subtitle">
                  <div style={{ marginBottom: '20px' }}>
                    <CustomLink title="support@name3.com" />
                  </div>
                  <CustomLink title="Telegram" />
                </div>
              </div>
            </div>
            <div className="contacts-info-item">
              <div className="contacts-info-item-image-wrapper">
                <img className="contacts-info-item-image" src={TimeIcon} alt={TimeIcon} />{' '}
              </div>
              <div className="contacts-info-item-content">
                <h3 className="contacts-info-item-title">{t('contacts:workTime')}</h3>
                <div className="contacts-info-item-subtitle">
                  <div style={{ display: 'flex', marginBottom: '20px' }}>
                    <div style={{ marginRight: '20px', fontWeight: 500, color: '#222' }}>
                      {t('contacts:monFr')}
                    </div>
                    9:00 - 20:00
                  </div>
                  <div style={{ display: 'flex' }}>
                    <div style={{ marginRight: '20px', fontWeight: 500, color: '#222' }}>
                      {t('contacts:sunSat')}
                    </div>
                    10:00 - 18:00
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <img src={LetterBox} alt={LetterBox} className="contacts-image-1" />
        <img src={EllipseImage} alt={EllipseImage} className="contacts-image-2" />
        <img src={EllipseImage} alt={EllipseImage} className="contacts-image-3" />
        <img src={EllipseImage} alt={EllipseImage} className="contacts-image-4" />
      </div>
    </div>
  );
};
